import { types as sdkTypes } from '../../util/sdkLoader';
import { hasKeywordSearchParams, hasLocationSearchParams } from '../../util/searchPageQueryParams';

const { LatLng, LatLngBounds } = sdkTypes;

export const WORLD_BOUNDS = new LatLngBounds(new LatLng(85, 180), new LatLng(-85, -180));

export const boundsFromListings = listings => {
  const listingsWithGeolocation = (Array.isArray(listings) ? listings : []).filter(listing => {
    const geolocation = listing?.attributes?.geolocation;
    return Number.isFinite(geolocation?.lat) && Number.isFinite(geolocation?.lng);
  });

  if (!listingsWithGeolocation.length) {
    return null;
  }

  const maxAndMinCoordinates = listingsWithGeolocation.reduce(
    (acc, listing) => {
      const geolocation = listing.attributes.geolocation;
      return {
        maxLat: Math.max(acc.maxLat, geolocation.lat),
        minLat: Math.min(acc.minLat, geolocation.lat),
        maxLng: Math.max(acc.maxLng, geolocation.lng),
        minLng: Math.min(acc.minLng, geolocation.lng),
      };
    },
    {
      maxLat: -Infinity,
      minLat: Infinity,
      maxLng: -Infinity,
      minLng: Infinity,
    }
  );

  return new LatLngBounds(
    new LatLng(maxAndMinCoordinates.maxLat, maxAndMinCoordinates.maxLng),
    new LatLng(maxAndMinCoordinates.minLat, maxAndMinCoordinates.minLng)
  );
};

export const resolveSearchMapBounds = ({ searchParamsInURL, listings }) => {
  const boundsInURL = searchParamsInURL?.bounds || null;
  if (boundsInURL) {
    return boundsInURL;
  }

  const keywordSearchActive = hasKeywordSearchParams(searchParamsInURL);
  const locationSearchActive = hasLocationSearchParams(searchParamsInURL);
  const shouldFitToKeywordResults = keywordSearchActive && !locationSearchActive;

  if (!shouldFitToKeywordResults) {
    return boundsInURL;
  }

  return boundsFromListings(listings) || WORLD_BOUNDS;
};
